export default __webpack_public_path__ + "static/media/touchstay.282d6e9a.png";